import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../../services/admin.service';
import { Position } from '../../../../../models/position.model';
import { Response } from '@angular/http';
import { Group } from '../../../../../models/group.model';

@Component({
  selector: 'app-rename-position',
  templateUrl: './rename-position.component.html',
  styleUrls: ['./rename-position.component.css']
})
export class RenamePositionComponent implements OnInit {
  public pos: Position;
  public newName: string;
  public group: Group;

  public disabledBtn = false;
  public successInfo = false;
  public errorInfo = false;
  public errorSix = false; // 406
  public errorTwelve = false; // 412
  public successEight = false; // 208

  constructor(public activeModal: NgbActiveModal,
    private adminService: AdminService) {
  }

  ngOnInit() {
  }

  setPositionForRename(p) {
    this.pos = p;
    this.newName = p.name;
  }

  setGroup(g) {
    this.group = g;
  }

  renameGroup() {
    this.disabledBtn = true;
    this.successInfo = false;
    this.successEight = false; // 208
    this.errorInfo = false;
    this.errorSix = false; // 406
    this.errorTwelve = false; // 412

    if (this.newName.length >= 5) {
      this.adminService.renamePosGlobal(this.pos.id, this.newName).subscribe(
        (res: any) => {
          if (res.status === 200) {

            this.pos.name = this.newName;

            this.successInfo = true;
            this.errorInfo = false;
            this.errorSix = false; // 406
            this.errorTwelve = false; // 412
            this.disabledBtn = false;
            this.successEight = false; // 208
          }
        },
        () => {
          this.errorInfo = true;
        }
      );
    } else {
      this.errorSix = true;
    }
  }

  disableBtnValidation() {
    return this.newName.length < 5;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-group/popups/rename-position/rename-position.component.ts